<template>
  <div ref="wrapper" class="relative w-[160px]">
    <button
      type="button"
      role="combobox"
      :aria-expanded="isOpen"
      class="filter-trigger flex h-9 w-full items-center justify-between whitespace-nowrap border border-input bg-transparent px-3 py-2 !text-sm shadow-sm ring-offset-background focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
      @click="isOpen = !isOpen"
    >
      <span class="pointer-events-none">{{ labelAlias[value] }}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="h-4 w-4 opacity-50"
        aria-hidden="true"
      >
        <path d="m6 9 6 6 6-6" />
      </svg>
    </button>
    <div
      v-show="isOpen"
      class="filter-menu absolute z-10 mt-1 w-full overflow-hidden border border-border bg-card shadow-sm"
    >
      <div
        v-for="option in options"
        :key="option.value"
        class="cursor-pointer px-3 py-2 !text-sm text-foreground hover:bg-accent transition-colors"
        @click="select(option.value)"
      >
        {{ option.label }}
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref } from 'vue';
import { onClickOutside } from '@vueuse/core';

export default defineComponent({
  name: 'RequestPartnerListFilter',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  emits: ['handleValueChange'],
  setup(_props, { emit }) {
    const isOpen = ref(false);
    const wrapper = ref(null);

    onClickOutside(wrapper, () => {
      isOpen.value = false;
    });

    const labelAlias = {
      '7d': 'Last week',
      '1m': 'Last month',
      '3m': 'Last 3 months',
      '6m': 'Last 6 months',
      '1y': 'Last year',
      '2y': 'Last 2 year',
    };

    const options = [
      { value: '7d', label: 'Last week' },
      { value: '1m', label: 'Last month' },
      { value: '3m', label: 'Last 3 months' },
      { value: '6m', label: 'Last 6 months' },
      { value: '1y', label: 'Last year' },
      { value: '2y', label: 'Last 2 year' },
    ];

    const select = (field) => {
      emit('handleValueChange', field);
      isOpen.value = false;
    };

    return {
      isOpen,
      wrapper,
      labelAlias,
      options,
      select,
    };
  },
});
</script>
<style scoped>
.filter-trigger {
  border-radius: 0.375rem;
}
.filter-menu {
  border-radius: 0.375rem;
}
</style>
